import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

export function SignaturePad({
  value,
  onChange,
  label,
  error,
}: {
  value: string;
  onChange: (signatureDataUrl: string) => void;
  label?: string;
  error?: string;
}) {
  const padRef = useRef<SignatureCanvas | null>(null);
  const [mode, setMode] = useState<"draw" | "type">(value && !value.startsWith("data:") ? "type" : "draw");
  const [typed, setTyped] = useState<string>(value && !value.startsWith("data:") ? value : "");

  const clearDraw = () => {
    padRef.current?.clear();
    onChange("");
  };
  const handleEnd = () => {
    const pad = padRef.current;
    if (!pad) return;
    const url = pad.isEmpty() ? "" : pad.toDataURL("image/png");
    onChange(url);
  };
  const switchMode = (m: "draw" | "type") => {
    setMode(m);
    if (m === "draw") {
      setTyped("");
      onChange("");
    } else {
      clearDraw();
    }
  };

  return (
    <div>
      {label && <span className="field-label">{label}</span>}
      <div className="mb-2 flex gap-2 text-xs">
        <button
          type="button"
          onClick={() => switchMode("draw")}
          className={`px-2 py-1 rounded border ${mode === "draw" ? "border-program bg-program text-white" : "border-slate-300"}`}
        >
          Draw
        </button>
        <button
          type="button"
          onClick={() => switchMode("type")}
          className={`px-2 py-1 rounded border ${mode === "type" ? "border-program bg-program text-white" : "border-slate-300"}`}
        >
          Type
        </button>
      </div>
      {mode === "draw" ? (
        <div className="border border-slate-300 rounded bg-white">
          <SignatureCanvas
            ref={(r) => {
              padRef.current = r;
            }}
            penColor="#1e293b"
            canvasProps={{
              width: 420,
              height: 120,
              className: "w-full h-[120px] rounded",
            }}
            onEnd={handleEnd}
          />
          <div className="flex justify-end p-1">
            <button type="button" onClick={clearDraw} className="text-xs text-slate-500 underline">
              Clear
            </button>
          </div>
        </div>
      ) : (
        <input
          type="text"
          className="field-input italic"
          placeholder="Type your full name"
          value={typed}
          onChange={(e) => {
            setTyped(e.target.value);
            onChange(e.target.value);
          }}
        />
      )}
      {error && <p className="field-error">{error}</p>}
    </div>
  );
}
